import { Button, Classes, Dialog, Drawer, Collapse, Intent } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { toJS } from 'mobx';

import { locale, loadMessages } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { CheckboxInputFormField, TextInputFormField, SwitchInputFormField, DateInputFormField } from '../../common/form';
import VerticalForm from '../../common/form/VerticalForm';
import { Form } from 'react-final-form';
import LeaveRouteDirtyWrapper from '../../common/LeaveRouteDirtyWrapper';

import {
  DataGrid,
  Column,
  SearchPanel,
  Button as DGButton,
  DataGridTypes,
  Export,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  Toolbar,
  Item,
  ColumnChooser,
  FilterPanel,
  Sorting,
  MasterDetail,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { TLCode, Page } from '../../../common/enums';
import { Instance } from 'mobx-state-tree';
import moment from 'moment';
import withTranslate, { WithTranslateProps } from '../../common/WithTranslate';
import TranslatedMessage from '../../common/translation/TranslatedMessage';
import { TransferRequest } from '../../../store/models/TransferRequest'


interface ProtectionDialogProps extends WithTranslateProps {
  isOpen: boolean;
  onClose,
  onCancel,
  message?: string;
  messageContent?: JSX.Element;
  confirmText?: string;
  cancelText?: string;
  transfer?: any;
  save: (data: any) => void;
  terminate: (data: any) => void;
}

type ProtectionFormValues = {
  latitude: number;
  longitude: number;
};

type ProtectionFormProps = {
  onSubmit: (values: ProtectionFormValues) => void | Promise<void>;
  initialValues?: Partial<ProtectionFormValues>;
};

export const ProtectionDialog = ({
  isOpen,
  onClose,
  onCancel,
  translate,
  transfer,
  save,
  terminate
}: ProtectionDialogProps) => {

  const handleTerminate = async (data: any) => {
    await terminate(data);
  }
  const handleClose = (withResetDatas: boolean) => {
    if (withResetDatas){
    }

    if (onClose) {
      onClose(!withResetDatas);
    }
  };


  loadMessages(frMessages);
  locale('fr');

  //initialValues={{ ...bankHolidayDate, date: moment(bankHolidayDate.date, 'DD/MM/YYYY').toDate() }}

  if (transfer != undefined) {
    transfer.dateDemande = moment(transfer.requestDate, 'YYYY-MM-DDTHH:mm:ss').toDate();
    transfer.dateDecision = (transfer.decisionDate != "")?moment(transfer.decisionDate, 'YYYY-MM-DDTHH:mm:ss').toDate():null;
    transfer.date1ePublication = (transfer.firstPublishDate != "")?moment(transfer.firstPublishDate, 'YYYY-MM-DDTHH:mm:ss').toDate():null;
    transfer.date1ePublicationPostDecision =(transfer.firstPublishDateAfterDecision != "")? moment(transfer.firstPublishDateAfterDecision, 'YYYY-MM-DDTHH:mm:ss').toDate():null;
    transfer.dateDeb = moment(transfer.startDate, 'YYYY-MM-DDTHH:mm:ss').toDate();
    transfer.dateFin =(transfer.endDate.startsWith('9999'))?null:moment(transfer.endDate, 'YYYY-MM-DDTHH:mm:ss').toDate();
  }

  return (

    <>
      <Dialog isOpen={isOpen} canOutsideClickClose={false} style={{ width: '1410px', height: '100%', zIndex: 1001 }} >
        <div className={Classes.DIALOG_HEADER}>
          {/* <h1>{title}</h1> */}
        </div>
        <div className={Classes.DIALOG_BODY}>
          <br />
          {/* {messageContent !== undefined ? messageContent : message} */}
                  <Form
                    //initialValues={toJS(transfer) || {}}
                    initialValues={toJS(transfer) || {}}
                    onSubmit={(values) => {

                      if (values["dateDeb"] != null) values["startDate"] = moment(values["dateDeb"]).format('YYYY-MM-DDTHH:mm:ss');
                      if (values["dateFin"] != null) values["endDate"] = moment(values["dateFin"]).format('YYYY-MM-DDTHH:mm:ss');


                      save(values);
                    }}
                    render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
                      <form onSubmit={handleSubmit}>
                        <LeaveRouteDirtyWrapper blockChange={dirty} />
                        <Container>
                          <VerticalForm labelWidth={225}>
                            <DivLine style={{ display: 'flex', justifyContent: 'center' }}>
                              <DivColumn>
                                {transfer != undefined && (
                                  <>
                                    <DateInputFormField 
                                      name="dateDemande"
                                          label={TLCode.TRANSFER_REQUEST_requestDate}
                                          inline={true}
                                          fill={true}
                                          disabled={true}
                                    />
                                    <DateInputFormField
                                      name="dateDecision"
                                          label={TLCode.TRANSFER_REQUEST_decisionDate}
                                          inline={true}
                                          fill={true}
                                          disabled={true}
                                    />
                                    <DateInputFormField
                                      name="date1ePublication"
                                          label={TLCode.TRANSFER_REQUEST_firstPublishDate}
                                          inline={true}
                                          fill={true}
                                          disabled={true}
                                    />
                                    <DateInputFormField
                                      name="date1ePublicationPostDecision"
                                          label={TLCode.TRANSFER_REQUEST_firstPublishAfterDecisionDate}
                                          inline={true}
                                          fill={true}
                                          disabled={true}
                                    />
                                    <DateInputFormField
                                      name="dateDeb"
                                          label={TLCode.PROTECTION_StartDate}
                                          inline={true}
                                          fill={true}
                                          disabled={false}
                                    />
                                    <DivLine>
                                      <DateInputFormField
                                        name="dateFin"
                                            label={TLCode.PROTECTION_EndDate}
                                            inline={true}
                                            fill={true}
                                            disabled={false}
                                      />
                                      {(transfer.endDate.startsWith('9999')) &&
                                      <Button onClick={(e) => {
                                          handleClose(true);
                                          handleTerminate(transfer.protectionId);
                                        }}
                                        intent={Intent.DANGER} disabled={false}
                                        style={{ marginLeft: '5px', height:'20px' }}>
                                        {translate(TLCode.PROTECTION_Terminate)}
                                      </Button>
                                      }
                                    </DivLine>
                                    <DivLine>
                                      <DivColumn><b>{translate(TLCode.TRANSFER_Address)}</b>&nbsp;</DivColumn>
                                      <DivColumn>&nbsp;{transfer.initialAddress}&nbsp;{transfer.initialZipCode}&nbsp;{transfer.initialCity}</DivColumn>
                                    </DivLine>
                                    <DivLine>
                                      <DivColumn><b>{translate(TLCode.TRANSFER_NewAddress)}</b>&nbsp;</DivColumn>
                                      <DivColumn>
                                        &nbsp;{transfer.newAddress}&nbsp;{transfer.newZipCode}&nbsp;{transfer.newCity}</DivColumn>
                                    </DivLine>
                                    <TextInputFormField
                                          name="latitude"
                                          label={TLCode.PROTECTION_Latitude}
                                          inline={true}
                                          fill={true}
                                          disabled={false}
                                        />
                                    <TextInputFormField
                                          name="longitude"
                                          label={TLCode.PROTECTION_Longitude}
                                          inline={true}
                                          fill={true}
                                          disabled={false}
                                        />
                                  </>
                                )}
                              </DivColumn>
                            </DivLine>

                          </VerticalForm>
                        </Container>
                        <div className={Classes.DIALOG_FOOTER}>
                          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button type="submit" onClick={() => handleClose(false)} intent={Intent.PRIMARY} disabled={false}>
                              {translate(TLCode.GENERAL_Save)}
                            </Button>
                            <Button onClick={() => handleClose(true)} intent={Intent.DANGER} disabled={false} style={{ marginLeft: '5px' }}>
                              {translate(TLCode.GENERAL_Cancel)}
                            </Button>
                          </div>
                        </div>

                      </form>
                    )}
                  />
        </div>
      </Dialog>
    </>
  );
};

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Container = styled.div({
  display: 'flex',
  width: '85%',
  flexDirection: 'column',
});
